import type { DrawCeremonyPlan } from "./api";
import { formatDateTime } from "./dateFormat";

export const DRAW_MECHANICS_TEXT =
  "Mecánica del sorteo: estándar internacional — sembrado 1 arriba y 2 abajo; 3 y 4 sorteados en cuartos; 5 a 8 en octavos; 9 a 16 en dieciseisavos; los demás lugares se sortean.";

export const LEGACY_COMPETITION_FORMAT_TEXT = "Round Robin y después eliminación sencilla.";

export function drawCeremonyPlanFromPolicy(policy: Record<string, unknown> | null | undefined): DrawCeremonyPlan {
  const raw = policy && typeof policy === "object" ? (policy as Record<string, unknown>).draw_ceremony : null;
  if (!raw || typeof raw !== "object") return { enabled: false, scheduled_at: null };
  const entry = raw as Record<string, unknown>;
  const scheduled = typeof entry.scheduled_at === "string" && entry.scheduled_at.trim() ? entry.scheduled_at.slice(0, 16) : null;
  return { enabled: Boolean(entry.enabled), scheduled_at: scheduled };
}

/** Párrafo del sorteo para la convocatoria (campo Formato de competencia). */
export function drawCeremonyConvocatoriaText(plan: DrawCeremonyPlan | null | undefined): string {
  if (!plan?.enabled) return "";
  const when = plan.scheduled_at ? `${formatDateTime(plan.scheduled_at)} h (hora de la Ciudad de México)` : "fecha y hora por anunciar";
  return `Sorteo público del cuadro: ${when}. ${DRAW_MECHANICS_TEXT}`;
}

/** Texto default de "Formato de competencia": base + sorteo si habrá. */
export function competitionFormatDefault(plan: DrawCeremonyPlan | null | undefined): string {
  const sorteo = drawCeremonyConvocatoriaText(plan);
  return sorteo ? `${LEGACY_COMPETITION_FORMAT_TEXT}\n\n${sorteo}` : LEGACY_COMPETITION_FORMAT_TEXT;
}

/** Un texto guardado que sigue siendo el default viejo (o vacío) toma el
 * default nuevo; un texto editado por el admin se respeta. */
export function competitionFormatFollowingPlan(stored: string | null | undefined, plan: DrawCeremonyPlan | null | undefined): string {
  const current = (stored ?? "").trim();
  if (!current || current === LEGACY_COMPETITION_FORMAT_TEXT) return competitionFormatDefault(plan);
  return current;
}
